import { translitToRus } from 'app/utils';
import { createSelector } from 'reselect';
const userState = (state) => state.user;
export const itemsUserSelector = createSelector(userState, (user) => user.items);
export const searchValueUserSelector = createSelector(userState, (user) => user.searchValue);
export const selectedItemUserSelector = createSelector(userState, (user) => user.selectedItem);
export const sortItemsUserSelector = createSelector([itemsUserSelector, searchValueUserSelector], (items, searchValue) => {
    const compareFn = (a, b) => a.name.localeCompare(b.name);
    if (searchValue.length) {
        return items
            .filter((item) => translitToRus(item.name).indexOf(translitToRus(searchValue)) !== -1 || item.email.indexOf(searchValue) !== -1)
            .sort(compareFn)
            .sort((a, b) => Number(b.active) - Number(a.active));
    }
    return items.sort(compareFn).sort((a, b) => Number(b.active) - Number(a.active));
});
